// extracted by mini-css-extract-plugin
export default {"container":"EmailPeriod_container__OeXX8","icon":"EmailPeriod_icon__i7rRj"};